// frontend/shared-ui/src/components/Panel.jsx
import React from "react";

/**
 * A generic titled content panel with optional header actions.
 *
 * Renders:
 *   ┌────────────────────────────────────┐
 *   │ ▎ Title                    [action] │
 *   │   subtitle                          │
 *   ├────────────────────────────────────┤
 *   │ body                                │
 *   └────────────────────────────────────┘
 *
 * The `tone` prop controls the accent bar color.
 * Any unknown `className` is appended for per-page overrides.
 */
export default function Panel({
  title,
  subtitle,
  actions,
  tone = "primary", // primary | success | warning | danger | info | purple
  children,
  className = "",
  bodyClassName = "",
  noBodyPadding = false,
}) {
  const classes = ["fh-panel", `fh-panel--${tone}`, className]
    .filter(Boolean)
    .join(" ");

  const bodyClasses = [
    "fh-panel__body",
    noBodyPadding ? "fh-panel__body--flush" : "",
    bodyClassName,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section className={classes}>
      {(title || actions) && (
        <header className="fh-panel__head">
          <div className="fh-panel__title-wrap">
            <span className="fh-panel__accent" />
            <div className="fh-panel__titles">
              {title && <h3 className="fh-panel__title">{title}</h3>}
              {subtitle && <p className="fh-panel__subtitle">{subtitle}</p>}
            </div>
          </div>
          {actions && <div className="fh-panel__actions">{actions}</div>}
        </header>
      )}
      <div className={bodyClasses}>{children}</div>
    </section>
  );
}
